import _styled from "styled-components";
import { takeFirst } from "~/features/app/utils";
import { Link } from "~/features/ui/link";
import { Button } from "~/features/ui/button";
import { graphql, useFragment, type FragmentType } from "~/gql/runtime";
import { isLinkValid } from "~/features/ui/link/utils";
import ArrowRight from "~/public/icons/arrow-right.svg";
import ArrowTopRight from "~/public/icons/arrow-top-right.svg";
const fragment = graphql(`
  fragment LinkListLink on blocks_linkListLink_BlockType {
    title: baseText
    link: baseLink {
      ...Link
    }
  }
`);
type PlainLink = Record<string, unknown> & {
  href?: string;
  newWindow?: boolean;
  text?: React.ReactNode;
};
export type LinkListLinkViewProps = {
  link?: PlainLink | Array<PlainLink | null | undefined> | null;
  title?: string | null;
};
function getPlainLinkIcon(link?: PlainLink | null) {
  if (!link) {
    return undefined;
  }
  return link.newWindow ? ArrowTopRight : ArrowRight;
}
export function LinkListLinkView({
  title,
  link
}: LinkListLinkViewProps) {
  const cta = takeFirst(link);
  const icon = getPlainLinkIcon(cta);
  return <_StyledDiv>
      {title && <h3>{title}</h3>}
      {isLinkValid(cta) && <Button as={Link} variant="underline" icon={icon} {...cta} />}
    </_StyledDiv>;
}
export function LinkListLink(props: FragmentType<typeof fragment>) {
  const {
    title,
    link
  } = useFragment(fragment, props);
  return <LinkListLinkView title={title} link={link as LinkListLinkViewProps["link"]} />;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "link-list-link___StyledDiv",
  componentId: "sc-1r3yz22-0"
})({
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "gap": "1.6rem",
  "@media (min-width: 1024px)": {
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "space-between"
  }
});